import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('cv-language');
    return saved || 'no';
  });

  useEffect(() => {
    localStorage.setItem('cv-language', language);
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'no' ? 'en' : 'no');
  };

  const t = (noText, enText) => language === 'no' ? noText : enText;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
